import { createTheme } from '@mui/material/styles';
import type { DecisionColor, HvBand, Signal } from '@hv/shared';

export const BRAND = { navy: '#012169', gold: '#c9a227', grey: '#5b6770', bg: '#f3f5f8', line: '#e1e6ee', muted: '#5f6b78', ink: '#1f2933' };

export const DECISION_COLORS: Record<DecisionColor, { dot: string; bg: string; fg: string }> = {
  green: { dot: '#2f9e5f', bg: '#e7f6ec', fg: '#1a6b3c' },
  yellow: { dot: '#d9a628', bg: '#fdf4dc', fg: '#7a5a06' },
  blue: { dot: '#2f6fb0', bg: '#eaf1fb', fg: '#2c5a96' },
  red: { dot: '#c9433f', bg: '#fbe9e8', fg: '#9e322e' },
  grey: { dot: '#a9b2bd', bg: '#f0f2f5', fg: '#4f5b67' },
  grey_red: { dot: '#b07a78', bg: '#f4ecec', fg: '#7d4744' },
};

export const SIGNAL_COLORS: Record<Signal, { fg: string; bg: string }> = {
  governance: { fg: '#6b46c1', bg: '#efe9ff' },
  philanthropy: { fg: '#1f7a44', bg: '#e7f6ec' },
  university_ties: { fg: '#93600c', bg: '#fef3e2' },
  business_influence: { fg: '#12707c', bg: '#e6f4f6' },
  mentorship: { fg: '#b03060', bg: '#fdeef2' },
};

export const BAND_COLORS: Record<HvBand, string> = {
  high: '#2f9e5f',
  medium: '#d9a628',
  low: '#a9b2bd',
  unscored: '#d5dae1',
};

export const theme = createTheme({
  palette: {
    primary: { main: BRAND.navy },
    secondary: { main: BRAND.grey },
    background: { default: BRAND.bg, paper: '#ffffff' },
    text: { primary: BRAND.ink, secondary: BRAND.muted },
    success: { main: '#2f9e5f' },
    warning: { main: '#b8860b' },
    error: { main: '#c9433f' },
    info: { main: '#2f6fb0' },
    divider: BRAND.line,
  },
  shape: { borderRadius: 8 },
  typography: {
    fontFamily: '"Inter", "Segoe UI", system-ui, -apple-system, Roboto, Arial, sans-serif',
    h1: { fontSize: '1.15rem', fontWeight: 700 },
    h2: { fontSize: '1.25rem', fontWeight: 700 },
    h3: { fontSize: '1rem', fontWeight: 700 },
    h4: { fontSize: '0.8rem', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.04em', color: BRAND.muted },
    button: { textTransform: 'none', fontWeight: 600 },
  },
  components: {
    MuiButtonBase: { defaultProps: { disableRipple: false } },
    MuiPaper: { styleOverrides: { root: { boxShadow: '0 1px 3px rgba(1,33,105,.08), 0 1px 2px rgba(1,33,105,.06)' } } },
    MuiCssBaseline: {
      styleOverrides: {
        '*:focus-visible': { outline: `3px solid #2f6fb0`, outlineOffset: 2 },
        body: { backgroundColor: BRAND.bg },
      },
    },
  },
});
